import {
  Video, Mail, Presentation, Phone, MessageSquare, Brain, Sparkles,
  Zap, Share2, Compass, Globe, Code, FileText, Image, Music,
  Camera, Mic, Bot, Search, BarChart, Shield, Palette, Pencil,
  Monitor, Smartphone, Headphones, BookOpen, Database, Settings,
  type LucideIcon
} from "lucide-react";

/**
 * Maps a blog post's emoji or tool name to a Lucide icon
 * for consistent aesthetic across the site.
 */

const emojiToIcon: Record<string, LucideIcon> = {
  "🎬": Video,
  "📹": Video,
  "🎥": Video,
  "📧": Mail,
  "✉️": Mail,
  "📩": Mail,
  "📊": Presentation,
  "🎤": Mic,
  "📞": Phone,
  "☎️": Phone,
  "💬": MessageSquare,
  "🧠": Brain,
  "✨": Sparkles,
  "⚡": Zap,
  "📱": Smartphone,
  "🌐": Globe,
  "💻": Code,
  "👨‍💻": Code,
  "📝": FileText,
  "📄": FileText,
  "📋": FileText,
  "🖼️": Image,
  "🎨": Palette,
  "🎵": Music,
  "📸": Camera,
  "🤖": Bot,
  "🔍": Search,
  "📈": BarChart,
  "🔒": Shield,
  "🛡️": Shield,
  "✏️": Pencil,
  "🖥️": Monitor,
  "🎧": Headphones,
  "📚": BookOpen,
  "🗄️": Database,
  "⚙️": Settings,
  "🧩": Settings,
  "🔗": Share2,
  "🧭": Compass,
  "💡": Sparkles,
  "🚀": Zap,
  "🛠️": Settings,
  "🎯": Compass,
  "📺": Monitor,
  "🔊": Mic,
  "💼": FileText,
  "🏪": Monitor,
  "🏥": Shield,
  "🧑‍⚕️": Shield,
  "🍕": Bot,
  "📰": FileText,
  "🎙️": Mic,
  "🧑‍💼": Bot,
  "🏗️": Settings,
  "🎓": BookOpen,
  "📣": Share2,
  "🤝": MessageSquare,
  "🔄": Zap,
  "📉": BarChart,
  "🏢": Database,
  "💰": BarChart,
  "🧾": FileText,
  "📎": FileText,
  "🪄": Sparkles,
  "🎭": Palette,
  "🖌️": Palette,
};

export function getToolIcon(emoji: string): LucideIcon {
  return emojiToIcon[emoji] || Sparkles;
}
